import {useIsReservationSettingsReady} from './useIsReservationSettingsReady';

export function ReservationSettingsPreloader() {
  useIsReservationSettingsReady();
  return null;
}
